export interface IDashVolume {
    centerId?: number,
    centerAlias: string, 
    year: string, 
    janCount: number,
    febCount: number,
    marCount: number,
    aprCount: number,
    mayCount: number,
    junCount: number,
    julCount: number,
    augCount: number,
    sepCount: number,
    octCount: number,
    novCount: number,
    decCount: number,
    total: number
}